module.exports = __webpack_public_path__ + "img/relevance.3e48a55d.svg";